<template>
  <div>
    <!-- <el-row>
      <h2>未检测</h2>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="检测日期：">
            <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="queryTable(0)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="ITEM_NAME" label="检测项"></el-table-column>
          <el-table-column prop="ITEM_STANDARD" label="项目标准"></el-table-column>
          <el-table-column prop="ITEM_DEFAULT_VALUE" label="检测值">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ITEM_DEFAULT_VALUE"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="submitCheck" style="margin-top: 10px">提交</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryNotCheck, submitCheckFun } from 'api/checkDoc';
import date from '@/assets/common/date';
// import { getFormatDay } from '@/assets/common/common';

export default {
  props: {
    searchForm1: {
      type: Object,
      default: null,
    },
    currentPage1: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // searchForm: {
      //   date: getFormatDay(1, '-'),
      // },
      searchForm: this.searchForm1,
      currentPage: this.currentPage1,
      pageSize: 15,
      totalCount: 0,
      tableData: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // this.queryTable(0);
  },
  methods: {
    queryTable(pageIndex) {
      const params = {
        FTS_DAY: date(this.searchForm.date, '%F'),
        PAGEINDEX: pageIndex,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      queryNotCheck(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    submitCheck() {
      if (this.tableData.length == 0) {
        this.$message.show({ text: '未提交数据', type: 'warning' });
        return false;
      }
      let submitArr = [];
      submitArr = this.tableData.map((item) => ({
        PRODUCT_CODE: item.PRODUCT_CODE, STANDARD_ID: item.STANDARD_ID, ITEM_ID: item.ITEM_ID, ITEM_VALUE: item.ITEM_DEFAULT_VALUE,
      }));
      const params = {
        FTS_DAY: date(this.searchForm.date, '%F'),
        PRODUCT_ARRAY: submitArr,
      };
      submitCheckFun(params).then((result) => {
        this.$message.show({ text: '提交成功', type: 'success' });
        this.queryTable(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/foodSecurity/notCheckDoc.vue